<script lang="ts" setup>
import type { EditorialLookGridProps } from '@design-system/components/Editorial/EditorialLookGrid.props'
import type { EditorialGridFashionShowGallery } from '@integration-layer/ampliance/schemas/editorial-grid-fashion-show-gallery-schema.localized'
const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialGridFashionShowGallery
}>()

const data = await useComponentResponse<EditorialGridFashionShowGallery>(props)

const items: any = (data.value?.items ?? []).map(item => ({
  ...item,
}))

const transformedData: EditorialLookGridProps = {
  items: items,
  itemsPerPage: data.value?.itemsPerPage!,
}
</script>

<template>
  <div>
    <EditorialLookGrid v-bind="transformedData" />
  </div>
</template>
